module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/222.1e94ed9d.png";